<div class="custom" style="height: 100%; width: 100%">
  <div class="c404">
    <div class="container h-100">
      <div class="row">
        <div class="col text-center">
          <div class="h1-eq">404</div>
          <div class="h3-eq">No worry ! This page doesn't exist anymore.</div>
          <button
            type="button"
            onclick="window.location.href = '/login'"
            class="btn text-uppercase"
          >
            Back to home.
          </button>
          <div class="h3-eq">© Megalearning</div>
        </div>
      </div>
    </div>
  </div>
</div>
